import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';

export const getJobEntries = () => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getJobEntriesRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/job-entries',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getJobEntriesSuccess(res.data));
      })
      .catch(err => {
        dispatch(getJobEntriesFailure(err));
      });
  };
};

export const getJobEntryEventLogs = jobEntryId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: `/openempi-ws-rest/1.0/job-entries/${jobEntryId}/event-logs`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getJobEntryEventLogsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getJobEntryEventLogsFailure(err));
      });
  };
};

export const deleteJobEntry = jobEntryId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/job-entries/' + jobEntryId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteJobEntrySuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteJobEntryFailure(err));
      });
  };
};

const getJobEntriesRequest = () => {
  return {
    type: Constants.JOBENTRIES_GET_REQUEST
  };
};

const getJobEntriesSuccess = data => {
  return {
    type: Constants.JOBENTRIES_GET_SUCCESS,
    payload: data
  };
};

const getJobEntriesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.JOBENTRIES_GET_FAILURE,
    payload
  };
};

export const clearJobEntriesError = () => {
  return {
    type: Constants.JOBENTRIES_CLEAR_ERROR
  };
};

const deleteJobEntrySuccess = data => {
  return {
    type: Constants.JOBENTRIES_DELETE_SUCCESS,
    payload: data
  };
};

const deleteJobEntryFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.JOBENTRIES_DELETE_FAILURE,
    payload
  };
};

const getJobEntryEventLogsSuccess = data => {
  return {
    type: Constants.JOBENTRYEVENTLOGS_GET_SUCCESS,
    payload: data
  };
};

const getJobEntryEventLogsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.JOBENTRYEVENTLOGS_GET_FAILURE,
    payload
  };
};
